import { render } from "./SessionTagger.vue?vue&type=template&id=789ed9dc&scoped=true"
import script from "./SessionTagger.vue?vue&type=script&lang=js"
export * from "./SessionTagger.vue?vue&type=script&lang=js"

import "./SessionTagger.vue?vue&type=style&index=0&id=789ed9dc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789ed9dc"]])

export default __exports__